import { createGlobalStyle, keyframes } from 'styled-components';
const fadeIn = () => keyframes `
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
const fadeInBody = () => keyframes `
  from {
    transform: translate(0, -40px);
  }
  to {
    transform: translate(0, 0);
  }
`;
export const ConfirmAlertStyles = createGlobalStyle `
  body.react-confirm-alert-body-element {
    overflow: hidden;
  }

  .react-confirm-alert-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
    background: ${({ theme }) => (theme.themeId === 'primaryDark' ? 'rgba(0, 0, 0, 0.4)' : 'rgba(255, 255, 255, 0.75)')};
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    animation: ${fadeIn} 0.4s forwards;
  }

  .react-confirm-alert-body {
    font-family: Arial, Helvetica, sans-serif;
    width: 400px;
    padding: 30px;
    text-align: left;
    background: ${({ theme }) => theme.colors.grey00_1};
    border-radius: 10px;
    box-shadow: 0 20px 75px rgba(0, 0, 0, 0.13);
    color: #666;
  }

  .react-confirm-alert-svg {
    position: absolute;
    top: 0;
    left: 0;
  }

  .react-confirm-alert-body > h1 {
    margin-top: 0;
  }

  .react-confirm-alert-body > h3 {
    margin: 0;
    font-size: 16px;
  }

  .react-confirm-alert-button-group {
    display: flex;
    justify-content: flex-start;
    margin-top: 20px;
  }

  .react-confirm-alert-button-group > button {
    outline: none;
    background: ${({ theme }) => theme.colors.black_1};
    border: none;
    display: inline-block;
    padding: 6px 18px;
    color: ${({ theme }) => theme.colors.grey10_1}
;
    margin-right: 10px;
    border-radius: 5px;
    font-size: 12px;
    cursor: pointer;
  }
  #react-confirm-alert {
    .react-confirm-alert-overlay{
      z-index: 1050;
    }
    .react-confirm-alert {
      max-width: calc(100% - 30px);
      animation: ${fadeInBody} 0.35s forwards;
    }
  }
`;
